/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Backup_Saved_SuccessfullyInputs */

const en_automatic_save_backup_saved_successfully = /** @type {(inputs: Automatic_Save_Backup_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic backup saved successfully`)
};

const fr_automatic_save_backup_saved_successfully = /** @type {(inputs: Automatic_Save_Backup_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sauvegarde automatique enregistrée avec succès`)
};

const de_automatic_save_backup_saved_successfully = /** @type {(inputs: Automatic_Save_Backup_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Sicherung erfolgreich gespeichert`)
};

const it_automatic_save_backup_saved_successfully = /** @type {(inputs: Automatic_Save_Backup_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backup automatico salvato correttamente`)
};

const ru_automatic_save_backup_saved_successfully = /** @type {(inputs: Automatic_Save_Backup_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое резервное копирование успешно сохранено.`)
};

const es_automatic_save_backup_saved_successfully = /** @type {(inputs: Automatic_Save_Backup_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia de seguridad automática guardada correctamente`)
};

const zh_cn2_automatic_save_backup_saved_successfully = /** @type {(inputs: Automatic_Save_Backup_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动备份已成功保存`)
};

const ja_automatic_save_backup_saved_successfully = /** @type {(inputs: Automatic_Save_Backup_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動バックアップが正常に保存されました`)
};

const hi_automatic_save_backup_saved_successfully = /** @type {(inputs: Automatic_Save_Backup_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित बैकअप सफलतापूर्वक सहेज लिया गया`)
};

const pt_pt2_automatic_save_backup_saved_successfully = /** @type {(inputs: Automatic_Save_Backup_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cópia de segurança automática salva com sucesso.`)
};

/**
* | output |
* | --- |
* | "Automatic backup saved successfully" |
*
* @param {Automatic_Save_Backup_Saved_SuccessfullyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_backup_saved_successfully = /** @type {((inputs?: Automatic_Save_Backup_Saved_SuccessfullyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Backup_Saved_SuccessfullyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_backup_saved_successfully(inputs)
	if (locale === "de") return de_automatic_save_backup_saved_successfully(inputs)
	if (locale === "it") return it_automatic_save_backup_saved_successfully(inputs)
	if (locale === "ru") return ru_automatic_save_backup_saved_successfully(inputs)
	if (locale === "es") return es_automatic_save_backup_saved_successfully(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_backup_saved_successfully(inputs)
	if (locale === "ja") return ja_automatic_save_backup_saved_successfully(inputs)
	if (locale === "hi") return hi_automatic_save_backup_saved_successfully(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_backup_saved_successfully(inputs)
	return en_automatic_save_backup_saved_successfully(inputs)
});